import { render, staticRenderFns } from "./StatusDetail.vue?vue&type=template&id=ce0b57c4&scoped=true"
import script from "./StatusDetail.vue?vue&type=script&lang=js"
export * from "./StatusDetail.vue?vue&type=script&lang=js"
import style0 from "./StatusDetail.vue?vue&type=style&index=0&id=ce0b57c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0b57c4",
  null
  
)

export default component.exports